"use client";

import { trackContact } from "@/lib/analytics";

export function WhatsAppButton() {
  const phone = process.env.NEXT_PUBLIC_WHATSAPP_PHONE ?? "905558116813";
  const text = encodeURIComponent("Merhaba Ono MAC, ürünleriniz hakkında bilgi almak istiyorum ✨");
  const href = `https://wa.me/${phone}?text=${text}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp ile iletişime geç"
      onClick={() => trackContact("whatsapp")}
      className="fixed bottom-5 left-5 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/10 hover:scale-105 hover:shadow-xl transition-all sm:bottom-6 sm:left-6 sm:h-14 sm:w-14"
    >
      {/* WhatsApp icon SVG */}
      <svg viewBox="0 0 24 24" className="h-6 w-6 sm:h-7 sm:w-7" fill="currentColor" aria-hidden="true">
        <path d="M19.05 4.91A9.82 9.82 0 0 0 12.02 2C6.4 2 2 6.4 2 12.02c0 1.77.46 3.5 1.34 5.02L2 22l5.11-1.34A9.82 9.82 0 0 0 12.02 22c5.62 0 10.02-4.4 10.02-10.02 0-2.68-1.04-5.2-2.99-7.07ZM12.02 20.04c-1.51 0-3-.4-4.3-1.16l-.31-.18-3.03.79.79-2.96-.2-.3A8.03 8.03 0 0 1 4 12.02C4 7.6 7.6 4 12.02 4c2.14 0 4.15.83 5.66 2.34A7.95 7.95 0 0 1 20.02 12c0 4.42-3.6 8.04-8 8.04Zm6.54-11.28c-.18-.45-.93-.45-1.25-.46h-.3c-.26 0-.58.09-.9.45-.32.36-1.22 1.19-1.22 2.9s1.25 3.37 1.42 3.6c.18.23 2.46 3.76 5.97 5.27.29.12.52.18.7.23.29.07.55.06.76.04.23-.02.7-.29.8-.57.1-.28.1-.52.07-.57-.03-.05-.1-.08-.21-.13Z" />
      </svg>
      <span className="absolute -right-1 -top-1 hidden sm:flex h-5 w-5 items-center justify-center rounded-full bg-zinc-1000 text-xs font-bold text-white">1</span>
    </a>
  );
}
